import React, { ReactElement } from 'react';
import { useLocale } from 'client/i18n/hooks/useLocale';
import styled from '@emotion/styled';

const FlexFields = styled.div`
  display: flex;

  > * {
    flex: 1;
    &:not(:first-of-type) {
      margin-left: 10px;
    }
  }
`;

export const LocalizedDateSelector = ({
  daySelector,
  monthSelector,
  yearSelector,
}: LocalizedDateSelectorProps) => {
  const { locale } = useLocale();

  const dateParts = new Intl.DateTimeFormat(locale).formatToParts(new Date());

  const selectorMapping: { [key: string]: ReactElement } = {
    day: daySelector,
    month: <div style={{ flex: '1.5' }}>{monthSelector}</div>,
    year: yearSelector,
  };

  return (
    <FlexFields>
      {selectorMapping[dateParts[0].type]}
      {selectorMapping[dateParts[2].type]}
      {selectorMapping[dateParts[4].type]}
    </FlexFields>
  );
};

type LocalizedDateSelectorProps = {
  daySelector: ReactElement;
  monthSelector: ReactElement;
  yearSelector: ReactElement;
};
